import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { Table } from '@docpath/webcomponents/table';

import { Alias } from '../../../alias/models/alias';
import { Dge } from '../../../engines/models/dge';
import { Notification } from '../../models/notification';
import { NotificationOptions } from '../../models/notification-options';
import { FailedJobsService } from '../../services/failed-jobs.service';
import { FailedJobsHttpService } from '../../services/failed-jobs-http.service';
import { FailedJobsTableService } from './failed-jobs-table.service';

@Component({
  selector: 'app-failed-jobs-table',
  templateUrl: './failed-jobs-table.component.html'
})

export class FailedJobsTableComponent implements OnInit {

  @Input() filters: Filter[] = [];
  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  constructor(
    private readonly failedJobsTableService: FailedJobsTableService,
    private readonly failedJobsHttpService: FailedJobsHttpService,
    private readonly failedJobsService: FailedJobsService
  ) {
    this.table = this.failedJobsTableService.initTable();
  }


  ngOnInit(): void {
    this.failedJobsService.notificationOptionsLoaded.subscribe(result => {
      this.table.header = this.failedJobsTableService.initTableHeader();
      const notificationOptions = result as unknown as NotificationOptions;
      const notifications = notificationOptions.notifications as unknown as Notification[];
      const aliasOptions = notificationOptions.alias as unknown as Alias[];
      const dgesOptions = notificationOptions.dges as unknown as Dge[];
      if (notifications && aliasOptions && dgesOptions) {
        this.table.body = this.failedJobsTableService.initTableBody(new NotificationOptions(notifications, aliasOptions, dgesOptions));
      }
    });

    this.failedJobsHttpService.showLoadingChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });

    this.failedJobsTableService.loadNotifications([], 1, 25);

    this.tableLoaded.emit(this.table);
  }

  onChangeCheck(): void {
    this.selectedRow.emit();
  }

  onChangePage(page: number): void {
    this.failedJobsTableService.loadNotifications(this.filters, page);
  }

  onChangePageSize(size: number): void {
    this.failedJobsTableService.loadNotifications(this.filters, 1, size);
  }

  getCurrentPage(): number {
    return this.failedJobsTableService.getCurrentPage();
  }

  getCurrentSize(): number {
    return this.failedJobsTableService.getCurrentSize();
  }

  getElements(): number {
    return this.failedJobsTableService.getElements();
  }

}